/* eslint-disable */
import React, { lazy, Suspense, useLayoutEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import ProtectedPermissionRoute from './components/ProtectedPermissionRoute';
import AuthRoute from './components/AuthRoute';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/md-light-indigo/theme.css';
import './App.scss';

import Login from './view/Login/login';
import SuspenseLoader from './components/SuspenseLoader/SuspenseLoader';
import Home from './view/Home/Home';

const Unauthorized = lazy(() => import('./components/Unauthorized/Unauthorized'));
const ForgotPassword = lazy(() => import('./view/ForgotPassword/ForgotPassword'));
const ChangePassword = lazy(() => import('./view/ChangePassword/ChangePassword'));
const ManageUsers = lazy(() => import('./view/ManageUser/ManagerUser'));
const EditUser = lazy(() => import('./view/ManageUser/EditUser'));
const AddUser = lazy(() => import('./view/ManageUser/AddUser'));

const Wrapper = ({ children }: any) => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

function App() {
  return (
    
      <div className="app-main" role="main">
        <Suspense fallback={<SuspenseLoader />}>
          <Wrapper>
            <Routes>
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />

              <Route element={<ProtectedPermissionRoute requiredPermission="manage-users" />}>
                <Route path="/manage-users" element={<ManageUsers />} />
                <Route path="/edit-user/:id" element={<EditUser />} />
                <Route path="/edit-user" element={<EditUser />} />
                <Route path="/add-user" element={<AddUser />} />
              </Route>

                {/* Unauthorized Page */}
                <Route path="/unauthorized" element={<Unauthorized />} />
              </Route>
              <Route element={<AuthRoute />}>
                <Route path="/login" element={<Login />} />
                <Route path="/reset_password_submit" element={<ChangePassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
              </Route>        
            </Routes>
          </Wrapper>
        </Suspense>
      </div>
    
  );
}

export default App;
